export default "__VITE_ASSET__bbb959d6__"